(function () {
// Get the URL Params
const $147f09a420f36c2a$export$ec161d740909e39d = (query)=>{
    return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce((params, param)=>{
        let [key, value] = param.split("=");
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
        return params;
    }, {}) : {};
};
//check key validity in url_param array. Should return true if key is "truthy"
const $147f09a420f36c2a$export$ee27c052bca048fb = (input, params)=>{
    return input in params && params[input];
};
//check if value is numeric. Used for aff_ids and offer_ids
const $147f09a420f36c2a$export$e90fb89750dba83f = (input)=>{
    return parseInt(input) - 0 == parseInt(input);
};
/*
  function localStorageTest
  tests if localStorage is available to us.

  @params: None
  @return boolean     True if localstorage is available. False otherwise.
*/ // function to test if localstorage is available to us
function $147f09a420f36c2a$export$f32e8861c64da07a() {
    var test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}
function $147f09a420f36c2a$export$9f6791f3a9328167() {
    if (Object.keys(window.tdl.domain).length > 1) return true;
    else return false;
}
function $147f09a420f36c2a$export$c00ceb24f30fd356() {
    // if its just  single brand string , convert to object
    if (typeof window.tdl.domain == "string") window.tdl.domain = {
        "default": window.tdl.domain
    };
}
// function to test if cookies are available to us
function $147f09a420f36c2a$export$b836385cc7c9e9c6() {
    document.cookie = "cookie_test=test";
    let available = document.cookie.indexOf("cookie_test=") !== -1;
    //delete cookie
    document.cookie = "cookie_test=;max-age=0";
    return available;
}
function $147f09a420f36c2a$export$75af2e9927db4f50(domain) {
    document.cookie = "tunesdktest=test; domain=" + domain + "; max-age=60; path=/;";
    let setSuccessfully = document.cookie.indexOf("tunesdktest=") !== -1;
    document.cookie = "tunesdktest=;max-age=0;";
    return setSuccessfully;
}
//function to set first party cookie for network specific transaction id in the current domain
function $147f09a420f36c2a$export$110700823644f4a6(name, value, hostname, days) {
    try {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        let domain = "";
        if (hostname) domain = "; domain=." + hostname;
        document.cookie = name + "=" + (value || "") + domain + expires + "; path=/;";
        return true;
    } catch (e) {
        return false;
    }
}
//function to retrieve cookie 
function $147f09a420f36c2a$export$4be65e66cfa2648a(name, exact) {
    let values = [];
    const cookies = decodeURIComponent(document.cookie).split(";");
    for(let i = 0; i < cookies.length; i++){
        let cPair = cookies[i].split("=");
        // if the key matches exactly then add the value
        // of if we are not looking for an exact match and it contains the key, then add the value
        if (cPair[0].trim() == name || exact === false && cPair[0].trim().includes(name)) values.push(cPair[1].trim());
    }
    return values;
}
//function to access local storage
function $147f09a420f36c2a$export$d3720feff416e85b(name, exact) {
    let values = [];
    if (exact === true) {
        let val = window.localStorage.getItem(name);
        if (val) values.push(val);
    } else Object.keys(localStorage).filter((key)=>key.includes(name)).forEach((key)=>values.push(localStorage.getItem(key)));
    return values;
}


var $72418249e4b3dd51$var$Tune_SDK_Version = `SDK-VERSION-${"2.0.0"}-PIPELINE-${"393557"}`;
tdl.identify = $72418249e4b3dd51$var$identify;
tdl.convert = $72418249e4b3dd51$var$convert;
//checks to see if a string or object was passed, formats domain list to be object
(0, $147f09a420f36c2a$export$c00ceb24f30fd356)();
while(window.tdl.length){
    if (!tdl.domain) break;
    let funct = window.tdl.shift();
    let fn = funct[0];
    let args = funct.slice(1);
    let resolve = funct[2];
    let reject = funct[3];
    if (!resolve) resolve = ()=>{};
    if (!reject) reject = ()=>{};
    switch(fn){
        case "identify":
            $72418249e4b3dd51$var$identify(...args).then(resolve).catch(reject);
            break;
        case "convert":
            $72418249e4b3dd51$var$convert(...args).then(resolve).catch(reject);
            break;
    }
}
async function $72418249e4b3dd51$var$convert(options = {}) {
    let promises = [];
    // get param package from args and url string
    var params = {
        ...options,
        ...(0, $147f09a420f36c2a$export$ec161d740909e39d)(window.location.search)
    };
    for(const domain in window.tdl.domain){
        let transaction_ids = [];
        const address = $72418249e4b3dd51$var$getStorageAddress(options, domain);
        // if they passed offer in convert options, only convert transaction_ids with the offer id in the address
        const exact = address !== "tdl_" + domain;
        const tid_cookies = (0, $147f09a420f36c2a$export$4be65e66cfa2648a)(address, exact);
        // check cookies first
        if (tid_cookies.length > 0) transaction_ids = tid_cookies;
        // if we aren't looking for a specific offer or we couldn't find anything in cookies we should check localstorage
        if (!exact || transaction_ids.length == 0) {
            let tid_ls = (0, $147f09a420f36c2a$export$d3720feff416e85b)(address, exact);
            if (tid_ls.length > 0) transaction_ids = transaction_ids.concat(tid_ls);
        }
        // check if goal is required
        if ("goal_id" in options || "goal_ref" in options || "goal_name" in options) var tdl_url = window.tdl.domain[domain] + "/aff_goal?a=lsr&";
        else var tdl_url = window.tdl.domain[domain] + "/aff_lsr?";
        // promo code conversion does not need transaction_id.
        // if both promo_code and transaction_id exists for this domain, send both
        // along with all other options and let tracking engine validate and make decision.
        promises = promises.concat($72418249e4b3dd51$var$tidConvert(tdl_url, transaction_ids, options));
        if (promises.length == 0) promises = promises.concat($72418249e4b3dd51$var$promocodeConvert(tdl_url, options));
        // if no promise generated, transaction_id is missing and promo code is not available,
        // conversion is unattributable. ping tracking engine to emit metric
        if (promises.length == 0) promises = promises.concat($72418249e4b3dd51$var$generateUnattributable(window.tdl.domain[domain], params));
    }
    return Promise.allSettled(promises);
}
// function to attempt conversion with transaction_ids
function $72418249e4b3dd51$var$tidConvert(tdl_url, transaction_ids, options) {
    let conversions = [];
    let promises = [];
    if (transaction_ids.length > 0) {
        let encoded_url_params = $72418249e4b3dd51$export$33e2b2527725ca0(options);
        // if we have at least one transaction id, iterate through and add to url
        for (let tid of transaction_ids){
            let and = encoded_url_params.length > 0 ? "&" : "";
            conversions.push(`${encodeURI(tdl_url)}transaction_id=${tid}${and}${encoded_url_params}`);
        }
        for (let url of conversions)promises.push($72418249e4b3dd51$var$sendRequest(url));
    }
    // this will be empty if we didn't have transaction_ids
    return promises;
}
// function to attempt conversion with just promo code if no transaction_ids found
function $72418249e4b3dd51$var$promocodeConvert(tdl_url, options) {
    if ((0, $147f09a420f36c2a$export$ee27c052bca048fb)("promo_code", options)) {
        let encoded_url_params = $72418249e4b3dd51$export$33e2b2527725ca0(options);
        return [
            $72418249e4b3dd51$var$sendRequest(`${encodeURI(tdl_url)}${encoded_url_params}`)
        ];
    } else return [];
}
function $72418249e4b3dd51$export$33e2b2527725ca0(options, doExcludes = true) {
    let url_params = "";
    // these params are unecessary (and could cause issues) in the tracking engine with transaction_id
    let excludes = new Set([
        "offer_ref",
        "offer_id"
    ]);
    for(const p in options){
        if (doExcludes && excludes.has(p)) continue;
        if (!(0, $147f09a420f36c2a$export$ee27c052bca048fb)(p, options)) continue;
        let and = url_params.length > 0 ? "&" : "";
        let key = encodeURIComponent(p);
        let val = encodeURIComponent(options[p]);
        url_params += `${and}${key}=${val}`;
    }
    return url_params;
}
function $72418249e4b3dd51$var$sendRequest(url) {
    return fetch(url, {
        mode: "cors",
        headers: {
            "Tune-SDK-Version": $72418249e4b3dd51$var$Tune_SDK_Version
        }
    });
}
// ping tracking engine for metrics collection
function $72418249e4b3dd51$var$generateUnattributable(domain, options) {
    domain = domain.endsWith("/") ? domain.slice(0, -1) : domain;
    let url = `${domain}/ping`;
    // send all params from url with ping
    let encoded_url_params = $72418249e4b3dd51$export$33e2b2527725ca0(options, false);
    let encoded_url = encodeURI(url);
    url = encoded_url_params === "" ? `${encoded_url}` : `${encoded_url}?${encoded_url_params}`;
    return [
        $72418249e4b3dd51$var$sendRequest(url)
    ];
}
/*
Identify function
This is a more complex function.
It either stores the session or Creates and then stores the session.
It looks for the session in a URL param and in a specified variable

@params: None
@returns: None
*/ async function $72418249e4b3dd51$var$identify(defaults = {}, override = {}) {
    //check if more than network was passed when init'd
    var multiple_networks = (0, $147f09a420f36c2a$export$9f6791f3a9328167)();
    // get param package from defaults, url string and override
    var params = {
        ...defaults,
        ...(0, $147f09a420f36c2a$export$ec161d740909e39d)(window.location.search),
        ...override
    };
    // Determine network id to associate the click with
    if (multiple_networks && (0, $147f09a420f36c2a$export$ee27c052bca048fb)("network_id", params) && (0, $147f09a420f36c2a$export$ee27c052bca048fb)(params["network_id"], window.tdl.domain)) var network = params["network_id"];
    else if (!multiple_networks) var network = Object.keys(window.tdl.domain)[0];
    else // nothing, there are multiple networks and none of them were declared
    return;
    const address = $72418249e4b3dd51$var$getStorageAddress(params, network);
    // Check to see if session storage has been set for the address and assemble parameter list
    if (window.sessionStorage.getItem(address) === null) {
        // Case one: Transaction id has been passed, store transid
        if ((0, $147f09a420f36c2a$export$ee27c052bca048fb)("transaction_id", params)) $72418249e4b3dd51$var$storeSession(params["transaction_id"], address);
        else if (((0, $147f09a420f36c2a$export$ee27c052bca048fb)("aff_id", params) && (0, $147f09a420f36c2a$export$e90fb89750dba83f)(params.aff_id) || (0, $147f09a420f36c2a$export$ee27c052bca048fb)("aff_ref", params)) && ((0, $147f09a420f36c2a$export$ee27c052bca048fb)("offer_id", params) && (0, $147f09a420f36c2a$export$e90fb89750dba83f)(params.offer_id) || (0, $147f09a420f36c2a$export$ee27c052bca048fb)("offer_ref", params)) && !("transaction_id" in params)) {
            var session = await $72418249e4b3dd51$var$createSession(params, network);
            if (session) $72418249e4b3dd51$var$storeSession(session, address);
        } else return;
    } else // session has already been started, do nothing.
    return;
}
/*
  Function createSession.
  Creates a session in HasOffers by generating a click.

  @param Map         url_params            The query string parameters parsed from the current page url
  @param String      network      The Hasoffers tracking domain to use for the event.

  @return String     transaction_id generated by click.
*/ async function $72418249e4b3dd51$var$createSession(url_params, network) {
    let tdl_url = window.tdl.domain[network] + "/aff_c?";
    // loop the param list and attach params to the click url
    for(const p in url_params)if ((0, $147f09a420f36c2a$export$ee27c052bca048fb)(p, url_params)) tdl_url = tdl_url + "&" + p + "=" + url_params[p];
    tdl_url += "&format=json";
    //attempt to generate click, error out if failure
    const request = async ()=>{
        const encoded_url = encodeURI(tdl_url);
        const resp = await fetch(encoded_url, {
            mode: "cors",
            headers: {
                "Tune-SDK-Version": $72418249e4b3dd51$var$Tune_SDK_Version
            }
        });
        const json = await resp.json();
        const trans_id = json.response.data.transaction_id;
        return trans_id;
    };
    const tid = await request();
    return await tid;
}
/*
  function storeSession
  acts as a simple interface for local and remote storage

  @param     String      transaction_id
  @param     String      address=''          location of stored transaction_id
*/ function $72418249e4b3dd51$var$storeSession(transaction_id, address) {
    // If unable to set a cookie, set the value in localStorage as a fallback.
    if ((0, $147f09a420f36c2a$export$b836385cc7c9e9c6)() === true) $72418249e4b3dd51$var$cookieStore(transaction_id, address);
    else $72418249e4b3dd51$var$localStore(transaction_id, address);
}
/*
  function localStore
  acts as a simple interface for local and remote storage


  @param     String      transaction_id
  @param     String      address=''          location of stored transaction_id
*/ //store session in local storage
function $72418249e4b3dd51$var$localStore(transaction_id, address) {
    try {
        // Use sessionStorage to keep track of sessions that have already been identified
        window.sessionStorage.setItem(address, transaction_id.toString());
        window.localStorage.setItem(address, transaction_id.toString());
    } catch (e) {
        console.error(e);
    }
}
/*
  function cookieStore
  function to get the top level domain and set the first-party cookie

  @param     String      transaction_id
  @param     String      address=''         location of stored transaction_id
*/ // set the cookie domain to the top level domain and it will be available in all subdomains
function $72418249e4b3dd51$var$cookieStore(transaction_id, address) {
    //use session storage to keep track of sessions we have already identified
    try {
        window.sessionStorage.setItem(address, transaction_id.toString());
    } catch (e) {
        console.error(e);
    }
    // Attempt to set the cookie assuming a 1-part TLD, then 2-part TLD, etc. Check each time
    // If the cookie was successfully set and if not, keep expanding the domain on which the
    // cookie gets set.
    // The reasoning: we want to set a cookie on the root of the owned domain. This might be
    // something like "blah.com" or "blah.net", in which case the first hostname portion that
    // we try below would work. However, TLDs are not always 1-part like ".com" but could
    // be 2+ parts e.g. ".com.au". If that's the case, then the root of the domain on which to
    // set the cookie is "blah.com.au", and the browser would reject an attempt to set on ".com.au".
    let hostnames = window.location.hostname.split(".");
    let domain = "";
    for(let i = hostnames.length - 2; i >= 0; i--){
        let testDomain = hostnames.slice(i, hostnames.length).join(".");
        console.log("testing domain: ", testDomain);
        if ((0, $147f09a420f36c2a$export$75af2e9927db4f50)(testDomain)) {
            domain = testDomain;
            console.log("found domain: ", domain);
            break;
        }
    }
    if (domain !== "") return (0, $147f09a420f36c2a$export$110700823644f4a6)(address, transaction_id, domain, 1825);
    return false;
}
/*
  function getStorageAddress
  function to get the offer reference from the url parameters to use in storage identifier

  @param     object      all_params      Package of defaults, url string and override parameters
  @param     String      network         Network id to use for storage
  @return    String                      Address for stored transaction_id including the network and offer if available
*/ //
function $72418249e4b3dd51$var$getStorageAddress(all_params, network) {
    let offer = "";
    if ((0, $147f09a420f36c2a$export$ee27c052bca048fb)("offer_id", all_params) && (0, $147f09a420f36c2a$export$e90fb89750dba83f)(all_params.offer_id)) offer = "_" + all_params.offer_id;
    else if ((0, $147f09a420f36c2a$export$ee27c052bca048fb)("offer_ref", all_params)) offer = "_" + all_params.offer_ref;
    return "tdl_" + network + offer;
}

})();
//# sourceMappingURL=tune.js.map
